import { builder as defaultBuilder } from '@ogury/unmarshaller';

/**
 * Helper for builder an unmarshaller object
 *
 * @returns {Object}
 */
export const builder: UnmarshallerBuilder = {
  ...defaultBuilder,

  exists: (name: string, options = {}) => ({
    name,
    type: 'exists',
    parser: (x: string) => Boolean(x),
    ...options
  }),
  icon: (name: string, options = {}) => ({
    name,
    type: 'icon',
    parser: (x: string) => String(x),
    ...options
  }),
  color: (name: string, options = {}) => ({
    name,
    type: 'color',
    parser: (x: string) => String(x),
    ...options
  }),
  csv: (name: string, options = { delimiter: ' ' }) => ({
    name,
    type: 'csv',
    parser: (a: string) =>
      a.split(options.delimiter as string).map((b: string) => b.trim()),
    ...options
  }),
  array: (name: string, options = {}) => ({
    name,
    type: 'array',
    parser: (input: string) => (Array.isArray(input) ? (input as any[]) : []),
    ...options
  })
};
